import { ReactNode } from "react";
import { ToastContainer } from "react-toastify";

import Header from "../Header";
import NavBar from "../Navbar";
import Search from "../Search";
import Body from "../Body";
import Footer from "../Footer";
import Banners from "../Banners";
import BannerPopupModal from "../BannerPopupModal";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <>
    <Header />
    <NavBar />
    <Search />
    <Body>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
      />
      <Banners />
      <BannerPopupModal />
      {children}
    </Body>
    <Footer />
  </>
);

export default Layout;
